module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('dismissable-alert', {
    attrs: {
      "isShowing": _vm.isShowingReinvestmentNotice,
      "title": "Please take note!",
      "subtitle": "Transactions reinvested at the same rate/term on the same day will be reinvested together into one Note.",
      "notice": " Transactions that do not amount to $20 or greater when combined will be repaid to the default destination.",
      "alertType": "warning",
      "showIcon": true,
      "icon": "calendar-payment",
      "dismissible": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title top-margin bottom-margin"
  }, [_vm._v("Upcoming transactions")]), _vm._v(" "), (_vm.isExtraReinvestmentsEnabled) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._m(0), _vm._v(" "), (!_vm.hasAdditionalReinvestments) ? _c('div', [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.hasAdditionalReinvestments) ? _c('div', {
    staticClass: "table-responsive top-margin"
  }, [_c('table', {
    staticClass: "table table-striped additional-reinvestments-table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.additionalReinvestments), function(ar, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(Number(ar.amount))))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(ar.reinvestDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(ar.fundingSourceType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(ar.status === 'PENDING') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (ar.status === 'FUNDS_TRANSFERRED') ? _c('span', {
      staticClass: "label label-info"
    }, [_vm._v("Funds Transferred")]) : _vm._e(), _vm._v(" "), (ar.status === 'PROCESSED') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Processed")]) : _vm._e(), _vm._v(" "), (ar.status === 'CANCELLED') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (ar.status === 'FAILED') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(ar.status === 'PENDING') ? _c('button', {
      staticClass: "btn btn-danger btn-sm",
      attrs: {
        "type": "button",
        "disabled": _vm.cancellingReinvestmentId === ar.id
      },
      on: {
        "click": function($event) {
          _vm.confirmCancelReinvestment(ar)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.cancellingReinvestmentId === ar.id ? 'Cancelling...' : 'Cancel') + "\n                  ")]) : _vm._e(), _vm._v(" "), (ar.status === 'FUNDS_TRANSFERRED') ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("\n                    Transfer in progress\n                  ")]) : _vm._e()])])
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openAddAdditionalReinvestmentModal
    }
  }, [_c('em', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Additional Reinvestment\n            ")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_vm._m(3), _vm._v(" "), (!_vm.isThereAnyUpcomingTransactionWithNoAction()) ? _c('div', [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.isThereAnyUpcomingTransactionWithNoAction()) ? _c('div', _vm._l((_vm.notesTransactionsWithNoAction), function(nt, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "panel panel-default",
      attrs: {
        "id": "panelDemo1"
      }
    }, [_c('div', {
      staticClass: "panel-heading top-margin"
    }, [_c('div', {
      staticClass: "panel-title"
    }, [_vm._v("\n                  Transaction " + _vm._s(nt.transaction.transactionId) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "row notification"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "alert alert-info",
      attrs: {
        "role": "alert"
      }
    }, [_c('p', [_c('em', {
      staticClass: "icon icon-info pr-sm"
    }), _vm._v(_vm._s(_vm.getHeaderMessage()) + " "), _c('strong', [_vm._v(_vm._s(_vm.getAlertMessage(nt)))]), _vm._v("\n                      on " + _vm._s(_vm.formatDate(nt.transaction.maturityDate)) + ".")]), _vm._v(" "), _c('p', [_vm._v("Please note that you're able to change this payment using the options below.")])])])]), _vm._v(" "), _c('div', {
      staticClass: "row transation-info"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "row first-row"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm.formatDate(nt.transaction.maturityDate)))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(6, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v(_vm._s(nt.transaction.note.noteId))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "row first-row"
    }, [_vm._m(7, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm.getTypeOfPayment(nt.transaction.type)))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(8, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm.formatAmount(nt.transaction.amount)))])])])])]), _vm._v(" "), _vm._m(9, true), _vm._v(" "), _c('div', {
      staticClass: "transation-reinvest"
    }, [_c('div', {
      staticClass: "row"
    }, [_vm._m(10, true), _vm._v(" "), (_vm.isReinvestActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Rate and term")])]) : _vm._e(), _vm._v(" "), (_vm.isDonateActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Donation amount")])]) : _vm._e(), _vm._v(" "), (_vm.isCashoutActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Select bank account")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.action),
        expression: "nt.action"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "name": "action",
        "required": ""
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          nt.action = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.actionChanged(nt.action, index, false)
        }]
      }
    }, _vm._l((_vm.getActionsAllowedForThisTransaction()), function(action, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": action
        }
      }, [_vm._v(_vm._s(action.text) + " ")])
    }))]), _vm._v(" "), (_vm.isReinvestActionTaken(nt.action)) ? _c('div', [_c('CustomRateAndTerm', {
      attrs: {
        "manageRateAndTermGroupsId": nt.transaction.manageRateAndTermGroupsId,
        "mainContainer": 'left-padding',
        "term": nt.term,
        "rate": nt.rate,
        "nt": nt,
        "rateLimit": _vm.investmentsRestrictions.rateLimit
      },
      on: {
        "rateAndTermIsInvalid": function($event) {
          _vm.setRateAndTermAsInvalid(index, 'no-action')
        },
        "rateAndTermIsValid": function($event) {
          _vm.setRateAndTermAsValid(index, 'no-action')
        },
        "rateChanged": function($event) {
          _vm.setRate($event, index, 'no-action')
        },
        "termChanged": function($event) {
          _vm.setTerm($event, index, 'no-action')
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isDonateActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.amountForDonation),
        expression: "nt.amountForDonation"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "disabled": true,
        "required": ""
      },
      domProps: {
        "value": (nt.amountForDonation)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nt.amountForDonation = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.isCashoutActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.fundingSource),
        expression: "nt.fundingSource"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "name": "fundingSource",
        "required": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          nt.fundingSource = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_vm._l((_vm.fundingSources), function(fs, index) {
      return (fs.removed) ? _c('option', {
        key: index,
        attrs: {
          "disabled": "",
          "hidden": ""
        },
        domProps: {
          "value": fs
        }
      }, [_vm._v(_vm._s(fs.name))]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.fundingSources), function(fs, index) {
      return (!fs.removed) ? _c('option', {
        key: index,
        domProps: {
          "value": fs
        }
      }, [_vm._v(_vm._s(fs.name))]) : _vm._e()
    })], 2), _vm._v(" "), (_vm.shouldSubmitButtonBeDisabled(index, 'no-action')) ? _c('span', {
      staticClass: "error-feedback"
    }, [_vm._v("\n                      Please choose a bank account above or add one using the "), _c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.goToFundingSourcesSegment($event)
        }
      }
    }, [_vm._v("bank account section")])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('button', {
      staticClass: "btn btn-default btn-lg",
      attrs: {
        "type": "submit",
        "disabled": _vm.submitsDisabled || _vm.shouldSubmitButtonBeDisabled(index, 'no-action')
      },
      on: {
        "click": function($event) {
          _vm.submitUpcomingTransaction(nt)
        }
      }
    }, [_vm._v("Submit")])])])])])
  })) : _vm._e(), _vm._v(" "), _vm._m(11), _vm._v(" "), (!_vm.isThereAnyUpcomingTransactionWithAction()) ? _c('div', [_vm._m(12)]) : _vm._e(), _vm._v(" "), (_vm.isThereAnyUpcomingTransactionWithAction()) ? _c('div', _vm._l((_vm.notesTransactionsWithAction), function(nt, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "panel panel-default",
      attrs: {
        "id": "panelDemo1"
      }
    }, [_c('div', {
      staticClass: "panel-heading top-margin"
    }, [_c('div', {
      staticClass: "panel-title"
    }, [_vm._v("\n                  Transaction " + _vm._s(nt.transaction.transactionId) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "row notification"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "alert alert-success",
      attrs: {
        "role": "alert"
      }
    }, [_c('p', [_c('em', {
      staticClass: "icon-check pr-sm"
    }), _vm._v("You have chosen to "), _c('strong', [_vm._v(_vm._s(_vm.getAlertMessage(nt)))]), _vm._v("\n                      on " + _vm._s(_vm.formatDate(nt.transaction.maturityDate)) + ".")]), _vm._v(" "), _c('p', [_vm._v("Please note that you're able to change this payment using the options below.")])])])]), _vm._v(" "), _c('div', {
      staticClass: "row transation-info"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "row first-row"
    }, [_vm._m(13, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm.formatDate(nt.transaction.maturityDate)))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(14, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v(_vm._s(nt.transaction.note.noteId))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('div', {
      staticClass: "row first-row"
    }, [_vm._m(15, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm.getTypeOfPayment(nt.transaction.type)))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(16, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v(_vm._s(_vm.formatAmount(nt.transaction.amount)))])])])])]), _vm._v(" "), _vm._m(17, true), _vm._v(" "), _c('div', {
      staticClass: "transation-reinvest"
    }, [_c('div', {
      staticClass: "row"
    }, [_vm._m(18, true), _vm._v(" "), (_vm.isReinvestActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Rate and term")])]) : _vm._e(), _vm._v(" "), (_vm.isDonateActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Donation amount")])]) : _vm._e(), _vm._v(" "), (_vm.isCashoutActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('label', {
      staticClass: "value"
    }, [_vm._v("Select bank account")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.action),
        expression: "nt.action"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "name": "action",
        "required": ""
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          nt.action = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.actionChanged(nt.action, index, true)
        }]
      }
    }, _vm._l((_vm.getActionsAllowedForThisTransaction()), function(action, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": action
        }
      }, [_vm._v(_vm._s(action.text))])
    }))]), _vm._v(" "), (_vm.isReinvestActionTaken(nt.action)) ? _c('div', [_c('CustomRateAndTerm', {
      attrs: {
        "manageRateAndTermGroupsId": nt.transaction.manageRateAndTermGroupsId,
        "mainContainer": 'left-padding',
        "term": nt.term,
        "rate": nt.rate,
        "nt": nt,
        "rateLimit": _vm.investmentsRestrictions.rateLimit
      },
      on: {
        "rateAndTermIsInvalid": function($event) {
          _vm.setRateAndTermAsInvalid(index, 'action')
        },
        "rateAndTermIsValid": function($event) {
          _vm.setRateAndTermAsValid(index, 'action')
        },
        "rateChanged": function($event) {
          _vm.setRate($event, index, 'action')
        },
        "termChanged": function($event) {
          _vm.setTerm($event, index, 'action')
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isDonateActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.amountForDonation),
        expression: "nt.amountForDonation"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "disabled": true,
        "required": ""
      },
      domProps: {
        "value": (nt.amountForDonation)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          nt.amountForDonation = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.isCashoutActionTaken(nt.action)) ? _c('div', {
      staticClass: "col-md-6 left-padding"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (nt.fundingSource),
        expression: "nt.fundingSource"
      }],
      staticClass: "form-control input-lg",
      attrs: {
        "name": "fundingSource",
        "required": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          nt.fundingSource = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_vm._l((_vm.fundingSources), function(fs, index) {
      return (fs.removed) ? _c('option', {
        key: index,
        attrs: {
          "disabled": "",
          "hidden": ""
        },
        domProps: {
          "value": fs
        }
      }, [_vm._v(_vm._s(fs.name))]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.fundingSources), function(fs, index) {
      return (!fs.removed) ? _c('option', {
        key: index,
        domProps: {
          "value": fs
        }
      }, [_vm._v(_vm._s(fs.name))]) : _vm._e()
    })], 2), _vm._v(" "), (_vm.shouldSubmitButtonBeDisabled(index, 'action')) ? _c('span', {
      staticClass: "error-feedback"
    }, [_vm._v("\n                      Please choose a bank account above or add one using the "), _c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.goToFundingSourcesSegment($event)
        }
      }
    }, [_vm._v("bank account section")])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('button', {
      staticClass: "btn btn-default btn-lg",
      attrs: {
        "type": "submit",
        "disabled": _vm.submitsDisabled || _vm.shouldSubmitButtonBeDisabled(index, 'action')
      },
      on: {
        "click": function($event) {
          _vm.submitUpcomingTransaction(nt)
        }
      }
    }, [_vm._v("Submit")])])])])])
  })) : _vm._e()])])], 1), _vm._v(" "), _c('AddAdditionalReinvestment', {
    attrs: {
      "isVisible": _vm.showAdditionalReinvestmentModal,
      "availableNoteIds": _vm.getAvailableNoteIds(),
      "fundingSources": _vm.availableFundingSources
    },
    on: {
      "close": _vm.closeAddAdditionalReinvestmentModal,
      "save": _vm.saveAdditionalReinvestment
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 subtitle"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('em', {
    staticClass: "fa fa-exchange text-blue"
  }), _vm._v("Additional reinvestments")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "no-transactions"
  }, [_vm._v("\n                No additional reinvestments at the moment.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-right"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Reinvestment Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Funding Source")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Actions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 subtitle"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('em', {
    staticClass: "fa fa-exchange text-blue"
  }), _vm._v("Transactions you need to provide direction on")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "no-transactions"
  }, [_vm._v("\n                No transactions at the moment.\n              ")]), _vm._v(" "), _c('br'), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Transaction date:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Note number:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Payment type:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "line-separator top-margin"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "value"
  }, [_vm._v("Select from options below")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 subtitle"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('em', {
    staticClass: "fa fa-exchange text-gray"
  }), _vm._v("Transactions you've provided direction on")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', {
    staticClass: "no-transactions"
  }, [_vm._v("\n                No transactions at the moment.\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Transaction date:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Note number:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Payment type:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "line-separator top-margin"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 left-padding"
  }, [_c('label', {
    staticClass: "value"
  }, [_vm._v("Select from options below")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e13001a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UpcomingTransactions.vue
// module id = 2158
// module chunks = 1